<!--
 * @Description: 首页
-->
<template>
  <div class="home">
    <van-nav-bar v-show="$topBar" :title="$route.meta.title" fixed>
    </van-nav-bar>
    <div v-show="$topBar" class="comm-topbar-height"></div>
    <!-- height="300" -->
    <!-- <div class="title">
      <p>辽宁辽东水务控股有限责任公司</p>
    </div> -->
    <van-swipe class="my-swipe" :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="image" width="100%" height="100%" />
      </van-swipe-item>
      <div class="Index-title">
        <div class="wel">
          <!-- <span style="font-size: 15px;">{{nickname}}</span> -->
          <span>辽宁辽东水务控股有限责任公司</span>
        </div>
        <div class="tit-rig" v-show="avatar">
          <van-image round width="45" height="45" :src="avatar" />
        </div>
      </div>
    </van-swipe>
    <div class="top-List">
      <van-grid :column-num="4" :border="false">
        <van-grid-item v-for="(menu, i) in homeMenus" :key="i" icon="photo-o" :text="menu.name" @click="menuClick(menu)">
          <div slot="default">
            <div class="my-grid" :style="{ opacity: menu.path === '' ? 0.5 : 1 }">
              <div class="my-grid-icon">
                <img :src="menu.icon" alt="" width="26" />
              </div>
              <div class="my-grid-txt">{{ menu.name | ellipsis }}</div>
            </div>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <!-- 公告 -->
    <van-notice-bar left-icon="volume-o" :scrollable="false" color="#333" background="#fff">
      <template #left-icon>
        <div class="notice-left">
          <p>最新</p>
          <span>公告</span>
        </div>
      </template>
      <van-swipe vertical class="notice-swipe" width="100%" :autoplay="3000" :show-indicators="false">
        <van-swipe-item v-for="(notice, i) in noticeList" :key="i" @click="jumpDetail(notice)">
          <span>{{ notice.ftitle | dropdownEllipsis}}</span>
        </van-swipe-item>
      </van-swipe>
    </van-notice-bar>
    <!-- <div class="home-title">
      <van-row type="flex" justify="center">
        <van-col span="12">
          <router-link to="/business"> 
            <div class="yewu">
              <div class="yewu-business">
                <div class="yewu-business-left">
                  <p style="font-weight: bold;font-size: 14px;margin-bottom: 5px;">业务办理</p>
                  <p>足不出户办理</p>
                  <p>供水各项业务</p>
                </div>
                <div class="yewu-business-right">
                  <van-image :src="require('../../assets/images/yewubanli.png')"/>
                </div>
              </div>
            </div>
          </router-link>
        </van-col>
        <van-col span="12">   
          <router-link to="/butler">
            <div class="yewu" style="padding: 10px 10px 10px 5px;">
              <div class="yewu-business">
                <div class="yewu-business-left">
                  <p style="font-weight: bold;font-size: 14px;margin-bottom: 5px;">“水管家”服务</p>
                  <p>服务不打烊，为用</p>
                  <p>水户提供优质服务</p>
                </div>
                <div class="yewu-business-right" style="width: 39%;">
                  <van-image :src="require('../../assets/images/shuiguanjia.png')"/>
                </div>
              </div>
            </div>
          </router-link>       
        </van-col>
      </van-row>
    </div> -->

    <div class="waterFee">
      <div class="waterFee——title">历史用水变化</div>
      <div class="waterFee——head">
        <span @click.stop="dialogShow = !dialogShow">切换缴费号：{{ fuserno }}
          <span class="iconfont iconxiala" style="font-size: 12px"></span></span>
      </div>
      <div class="waterFee——content" ref="accessChart"></div>
    </div>
    <div style="height: 7px; width: 100%"></div>
    <div class="comm-homebar-height"></div>
    <home-bar></home-bar>
    <!-- 弹框 -->
    <van-popup v-model="dialogShow" position="bottom" :style="{ height: '30%' }">
      <van-picker title="缴费号选择" show-toolbar :columns="userColumns" @confirm="onConfirm" @cancel="dialogShow = false" />
    </van-popup>
  </div>
</template>

<script>
import HomeBar from "@/components/HomeBar.vue";
let EChart = require("echarts")

export default {
  name: "Home",
  data() {
    return {
      noticeList: [],
      usercom: '111',
      userno: '11111',
      year: new Date().getFullYear(),
      currentDate: new Date(),
      dialogShow: false,//弹框
      dropdownshow: false,
      nickname: localStorage.getItem('nickname'),
      avatar: localStorage.getItem('avatar'),
      userNumber: [
        { value: 0, text: '1' },
        { value: 1, text: '2' },
        { value: 2, text: '3' }
      ],
      images: [require("../../assets/images/shouye.png")],
      homeMenus: [
        {
          name: "我要绑定",
          icon: require("../../assets/images/bangding.png"),
          path: "bindManage",
        },
        {
          name: "水费查缴",
          icon: require("../../assets/images/jiaona.png"),
          path: "/pay/feePay",
        },
        {
          name: "水费账单",
          icon: require("../../assets/images/qingdan.png"),
          path: "/pay/shuifeizhangdan",
        },
        {
          name: "业务指南",
          icon: require("../../assets/images/zhinan.png"),
          path: "/guide/mustKnow?active=0",
        },
        {
          name: "业务办理",
          icon: require("../../assets/images/business1.png"),
          path: "/business",
        },
        {
          name: "停水公告",
          icon: require("../../assets/images/tingshui.png"),
          path: "butlerServe?active=0",
        },
        {
          name: "水质公告",
          icon: require("../../assets/images/shuizhi.png"),
          path: "butlerServe?active=1",
        },
        {
          name: "服务公告",
          icon: require("../../assets/images/fuwu.png"),
          path: "butlerServe?active=2",
        },
        {
          name: "水管家",
          icon: require("../../assets/images/butler1.png"),
          path: "/butler",
        },
        {
          name: "缴费方式",
          icon: require("../../assets/images/jiaofei.png"),
          path: "/guide/mustKnow?active=1",
        },
        {
          name: "水价标准",
          icon: require("../../assets/images/shuijia.png"),
          path: "/guide/mustKnow?active=2",
        },
        {
          name: "服务网点",
          icon: require("../../assets/images/wangdian.png"),
          path: "/guide/mustKnow?active=3",
        },
        {
          name: "服务承诺",
          icon: require("../../assets/images/chengnuo.png"),
          path: "/home/faq?active=1",
        },
        {
          name: "用水百科",
          icon: require("../../assets/images/baike.png"),
          path: "/home/faq?active=0",
        },
        {
          name: "政策法规",
          icon: require("../../assets/images/zhengcefagui.png"),
          path: "/home/xinwen?active=1",
        },
        {
          name: "公司新闻",
          icon: require("../../assets/images/gongsixinwen.png"),
          path: "/home/xinwen?active=0",
        },
        // {
        //   name: "更多",
        //   icon: require("../../assets/images/more.png"),
        //   path: "/home/Integratedservices",
        // },
      ],
      waterCostList: [],// 水费账单
      userList: [],
      fuserno: '',
      userColumns: [],
      waterFeeShow: false
    };
  },
  components: {
    HomeBar
  },
  filters: {
    dropdownEllipsis(value) {
      if (!value) return ''
      if (value.length > 18) {
        return value.slice(0, 18) + '...'
      }
      return value
    },
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 4) {
        return value.slice(0, 3) + "...";
      }
      return value;
    },
  },
  mounted() {
    this.getNotice()
    this.getUserList()
  },
  methods: {
    // 查询用户绑定户号
    getUserList() {
      this.$http.post(this.$api.userList, { pageindex: 1, pagesize: 20 }).then(res => {
        if (res.code === '000') {
          this.userList = res.data
          // 有绑定账号
          if (this.userList.length > 0) {
            // 查询水费账单
            this.userColumns = []
            let data = this.userList.filter(item => item.ftypeid == 0)
            if (data && data.length > 0) {
              this.fuserno = data[0].fuserno
              data.forEach(el => {
                this.userColumns.push({
                  text: el.fuserno
                })
              })
            }
            this.getWaterCostList()
          } else {
            // 未绑定账号

          }
        } else {
          this.$toast(res.msg)
        }
      })
    },
    // 查询水费账单
    getWaterCostList() {
      this.$http.post(this.$api.getFeeBill, { userno: this.fuserno }).then(res => {
        if (res.code === '000' && res.data) {
          this.waterCostList = res.data.DETAIL
          // 有清单
          if (this.waterCostList.length > 0) {
            this.waterFeeShow = true
            // 拼接统计图
            this.getChartData()
          } else {
            // 没清单
            this.waterFeeShow = false
          }
        } else {
          this.waterFeeShow = false
          this.$toast(res.msg)
        }
      })
    },
    // 拼接返回数据
    getChartData() {
      let data = this.waterCostList
      let timeData = [] //时间
      let seriesData = [] // 用水量
      for (var i = data.length - 1; i >= 0; i--) {
        timeData.push(data[i].LZNY) // 时间
        seriesData.push(data[i].WTVA) // 用水量
      }
      this.waterChart(timeData, seriesData)
    },
    jumpDetail(article) {
      this.$router.push({
        path: '/guide/articleDetail',
        query: {
          title: '首页公告',
          fid: article.fid
        }
      })
    },
    onConfirm(data) {
      if (this.fuserno != data.text) {
        this.fuserno = data.text
        this.getWaterCostList()
      }
      this.dialogShow = false
    },
    changeuserno(item) {
      this.dropdownshow = false
      this.userno = item.value
      this.usercom = item.text
    },
    // 图标
    waterChart(timeData, seriesData) {
      let ref = this
      let myChart = EChart.init(ref.$refs.accessChart)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        // tooltip: {
        //     trigger: 'axis'
        // },
        xAxis: {
          type: 'category',
          data: timeData
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '用水量',
          data: seriesData,
          type: 'bar',
          itemStyle: {
            color: EChart.graphic.LinearGradient(
              0, 0, 0, 1,
              [
                { offset: 0, color: '#83bff6' },
                { offset: 0.5, color: '#188df0' },
                { offset: 1, color: '#188df0' }
              ]
            )
          },
          emphasis: {
            itemStyle: {
              color: EChart.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#2378f7' },
                  { offset: 0.7, color: '#2378f7' },
                  { offset: 1, color: '#83bff6' }
                ]
              )
            }
          },
        }]
      }
      myChart.setOption(option, true)
    },
    // 公告
    getNotice() {
      let params = {
        "typecode": '114,115,125',
        "pagesize": 5,
        "pageindex": 1
      }
      this.$http.post(this.$api.getArticles, params).then(res => {
        if (res.code === '000') {
          this.noticeList = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
    businessImgClick() {
      this.$router.push("/business");
    },
    butlerImgClick() {
      this.$router.push("/butler");
    },
    menuClick(menu) {
      if (!menu.path) {
        this.$toast("待配置");
        return;
      }
      if (menu.name === '水费查缴') {
        if (!this.$comm.titleShow()) {
          this.$comm.userPay(menu)
        } else {
          location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa92e301d87f1aefe&redirect_uri=https%3A%2F%2Fwww.dlmeasure.com%2Fstatic%2Fduliang%2Fweixin%2Fapps%2Fbxzls%2Fms2%2F%23business%2Fwater&response_type=code&scope=snsapi_userinfo&state=bxzls#wechat_redirect'
        }
        return
      }
      if (menu.name === '我要绑定') {
        this.bindManage()
        return
      }
      this.$router.push({
        path: menu.path,
      });
    },
    bindManage() {
      this.$comm.bindManage()
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  .my-swipe {
    img {
      width: 100%;
      height: 100%;
    }
  }
  /deep/.van-swipe-item {
    font-size: 15px;
  }
  /deep/.van-notice-bar {
    padding: 10px;
    margin: 12px 15px;
    border-radius: 5px;
  }
  .notice-left {
    font-size: 12px;
    width: 12%;
    margin: 10px 15px 0 0;
    font-size: 10px;
    p {
      background: #c8000b;
      padding: 2px;
      color: #fff;
      text-align: center;
      margin-bottom: 3px;
      border-radius: 3px;
      margin: 0;
      height: 20px;
      line-height: 20px;
    }
    span {
      display: block;
      text-align: center;
      color: #0e1823;
    }
  }
  .notice-swipe {
    height: 40px;
    line-height: 40px;
  }

  .my-grid {
    text-align: center;

    .my-grid-icon {
      // height: 28px;
      .iconfont {
        font-size: 48px;
      }
    }

    .my-grid-txt {
      // margin-top: 15px;
      height: 32px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(33, 33, 33, 1);
    }
  }

  .belt {
    margin-top: 7px;
    // height: 124px;
    padding: 12px 16px;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 47.5%;
      // height: 100px;
    }
  }

  .home-title {
    margin-top: 12px;
    background: #ffffff;
    font-size: 15px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 44px;
    border-bottom: 1px solid #eee;
  }
}
.title {
  height: 69px;
  background-color: #2c82c9;
  position: relative;
  p {
    margin: auto;
    position: absolute;
    bottom: 0px;
    padding: 0px 0px 10px 20px;
    color: #fff;
  }
}
.Index-title {
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #fff;
  width: 100%;
  position: absolute;
  text-align: left;
  height: 60%;
  /deep/.van-button--mini {
    margin-left: 10px;
    padding: 0 10px;
  }
  h5 {
    font-size: 16px;
    margin: 0;
    font-weight: normal;
  }
  .wel {
    display: flex;
    align-items: center;
    margin: 20px 0 15px 0;
    font-size: 15px;
    padding: 6px 10px 10px 20px;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  p {
    font-size: 15px;
    margin: 10px auto;
  }
  h2 {
    font-size: 32px;
    margin: 0;
    font-weight: normal;
    margin: 5px 0 15px 0;
  }
}
.tit-rig {
  position: absolute;
  top: 48%;
  transform: translateY(-50%);
  right: 8%;
}
.top-List {
  background: #fff;
  padding: 10px 0;
  border-radius: 15px 15px 0 0;
  margin-top: -6%;
  position: relative;
}
/deep/.van-grid-item__content {
  padding: 8px;
}
/deep/.van-grid {
  background: #fff;
  padding: 10px 0;
}
.waterFee {
  background: #fff;
  margin: 10px 0 0 0;
  position: relative;
  &——title {
    font-size: 15px;
    padding: 10px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    display: inline-block;
  }
  &——head {
    display: inline-block;
    align-items: center;
    justify-content: center;
    position: absolute;
    padding: 0 2%;
    top: 5%;
    left: 48%;
    font-size: 14px;
    width: 48%;
    &__lift {
      height: 100%;
      width: 30%;
      flex: 1;
      font-size: 12px;
      // font-weight:bold;
      // z-index :99;
    }
    &__right {
      text-align: right;
      font-size: 14px;
      padding: 10px;
      height: 100%;
      width: 70%;
      margin-right: 10px;
      flex: 1;
      font-size: 12px;
      z-index: 99;
    }
  }
  &——content {
    min-height: 200px;
  }
}
.dropdown-menu {
  position: absolute;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.3);
  z-index: 99;
  margin-top: 15px;
  background: #fff;
  width: 70%;
  padding: 2%;
  right: 20px;
  .typeList {
    padding: 10px;
    font-size: 12px;
    text-align: left;
    p {
      margin: 0;
    }
    .active {
      color: #3e89f2;
      display: flex;
      align-items: center;
      span {
        width: 96%;
      }
    }
  }
}
/deep/.van-picker-column {
  width: 100%;
  flex: none;
}
.yewu {
  padding: 10px 5px 10px 10px;
  .yewu-business {
    position: relative;
    padding: 5px;
    height: 100px;
    background-color: #eaf3fc;
    .yewu-business-left {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      p {
        font-size: 12px;
        height: 20px;
        line-height: 20px;
        margin: 0px;
        color: black;
        font-weight: 500;
      }
    }
    .yewu-business-right {
      width: 50%;
      top: 56%;
      position: absolute;
      right: 0;
      transform: translateY(-50%);
    }
  }
}
</style>